import React, { createContext, ReactNode, useContext, useState } from "react";

interface SubHeaderType {
  subHeader: ReactNode;
  setSubHeader: (subHeader: ReactNode) => void;
}

const SubHeaderContext = createContext<SubHeaderType | undefined>(undefined);

interface TitleProviderProps {
  children: ReactNode;
}

export const SubHeaderProvider = ({ children }: TitleProviderProps) => {
  const [subHeader, setSubHeader] = useState<ReactNode>(<></>);

  return <SubHeaderContext.Provider value={{ subHeader, setSubHeader }}>{children}</SubHeaderContext.Provider>;
};
export const useSubHeader = (): SubHeaderType => {
  const context = useContext(SubHeaderContext);
  if (!context) {
    throw new Error("useTitle must be used within a SubHeaderProvider");
  }
  return context;
};
